import {
    changeDevicesWiFiDTO,
    Device,
    DeviceMoveDTO,
    DeviceResidentDTO,
    DeviceSocketUpdateDTO,
    devicesReqOptions,
    DevicesSettings,
    DeviceType,
    DeviceUpdateDTO,
    userTagSettingsDTO,
    userTagUpdateSocketDTO,
} from '.';
import { DeviceStatus, setUserNearbyDeviceSettingsDTO } from '../devicesStatuses';
import { MoveResidentWithDeviceResponceDTO } from '../residents';
import {
    IAddDeviceToResidentBySocket,
    IDeleteDeviceFromResidentBySocket,
    IDeleteResidentBySocket,
    IMoveResidentWithDevicesBySoket,
    IMoveResidentWithDevicesFailure,
    IMoveResidentWithDevicesRequest,
} from '../residents/types';

export enum DEVICES {
    GET_DEVICES_REQUEST = 'DEVICES.GET_DEVICES_REQUEST',
    GET_DEVICES_SUCCESS = 'DEVICES.GET_DEVICES_SUCCESS',
    GET_DEVICES_FAILURE = 'DEVICES.GET_DEVICES_FAILURE',

    GET_USER_TAG_DEVICES_REQUEST = 'DEVICES.GET_USER_TAG_DEVICES_REQUEST',
    GET_USER_TAG_DEVICES_SUCCESS = 'DEVICES.GET_USER_TAG_DEVICES_SUCCESS',
    GET_USER_TAG_DEVICES_FAILURE = 'DEVICES.GET_USER_TAG_DEVICES_FAILURE',

    GET_ONE_DEVICE_REQUEST = 'DEVICES.GET_ONE_DEVICE_REQUEST',
    GET_ONE_DEVICE_SUCCESS = 'DEVICES.GET_ONE_DEVICE_SUCCESS',
    GET_ONE_DEVICE_FAILURE = 'DEVICES.GET_ONE_DEVICE_FAILURE',

    GET_DEVICE_STATUSES_REQUEST = 'DEVICES.GET_DEVICE_STATUSES_REQUEST',
    GET_DEVICE_STATUSES_SUCCESS = 'DEVICES.GET_DEVICE_STATUSES_SUCCESS',
    GET_DEVICE_STATUSES_FAILURE = 'DEVICES.GET_DEVICE_STATUSES_FAILURE',

    GET_ALL_DEVICES_STATUSES_REQUEST = 'DEVICES.GET_ALL_DEVICE_STATUSES_REQUEST',
    GET_ALL_DEVICE_STATUSES_SUCCESS = 'DEVICES.GET_ALL_DEVICE_STATUSES_SUCCESS',
    GET_ALL_DEVICE_STATUSES_FAILURE = 'DEVICES.GET_ALL_DEVICE_STATUSES_FAILURE',

    CHANGE_DEVICE_REQUEST = 'DEVICES.CHANGE_DEVICE_REQUEST',
    CHANGE_DEVICE_SUCCESS = 'DEVICES.CHANGE_DEVICE_SUCCESS',
    CHANGE_DEVICE_FAILURE = 'DEVICES.CHANGE_DEVICE_FAILURE',
    CLEAR_SUCCESS_STATE = 'DEVICES.CLEAR_SUCCESS_STATE',

    GET_USER_NEARBY_REQUEST = 'DEVICES.GET_USER_NEARBY_REQUEST',
    GET_USER_NEARBY_SUCCESS = 'DEVICES.GET_USER_NEARBY_SUCCESS',
    GET_USER_NEARBY_FAILURE = 'DEVICES.GET_USER_NEARBY_FAILURE',

    GET_USER_NEARBY_SETTINGS_REQUEST = 'DEVICES.GET_USER_NEARBY_SETTINGS_REQUEST',
    GET_USER_NEARBY_SETTINGS_SUCCESS = 'DEVICES.GET_USER_NEARBY_SETTINGS_SUCCESS',
    GET_USER_NEARBY_SETTINGS_FAILURE = 'DEVICES.GET_USER_NEARBY_SETTINGS_FAILURE',

    SET_USER_NEARBY_SETTINGS_REQUEST = 'DEVICES.SET_USER_NEARBY_SETTINGS_REQUEST',
    SET_USER_NEARBY_SETTINGS_SUCCESS = 'DEVICES.SET_USER_NEARBY_SETTINGS_SUCCESS',
    SET_USER_NEARBY_SETTINGS_FAILURE = 'DEVICES.SET_USER_NEARBY_SETTINGS_FAILURE',

    MOVE_MANY_DEVICE_REQUEST = 'DEVICES.MOVE_MANY_DEVICE_REQUEST',
    MOVE_MANY_DEVICE_SUCCESS = 'DEVICES.MOVE_MANY_DEVICE_SUCCESS',
    MOVE_MANY_DEVICE_FAILURE = 'DEVICES.MOVE_MANY_DEVICE_FAILURE',

    CHANGE_DEVICES_WIFI_REQUEST = 'DEVICES.CHANGE_DEVICES_WIFI_REQUEST',
    CHANGE_DEVICES_WIFI_SUCCESS = 'DEVICES.CHANGE_DEVICES_WIFI_SUCCESS',
    CHANGE_DEVICES_WIFI_FAILURE = 'DEVICES.CHANGE_DEVICES_WIFI_FAILURE',

    MOVE_RESIDENT_WITH_DEVICES_SUCCESS = 'DEVICES.MOVE_RESIDENT_WITH_DEVICES_SUCCESS',

    SET_SETTINGS = 'DEVICES.SET_SETTINGS',
    CHANGE_SELECTED = 'DEVICES.CHANGE_SELECTED',
    GET_DEVICE_STATUS_BY_SOCKET = 'DEVICES.GET_DEVICE_STATUS_BY_SOCKET',

    UPDATE_DEVICE_BY_SOCKET = 'DEVICES.UPDATE_DEVICE_BY_SOCKET',
    ADD_DEVICE_BY_SOCKET = 'DEVICES.ADD_DEVICE_BY_SOCKET',
    DELETE_DEVICE_BY_SOCKET = 'DEVICES.DELETE_DEVICE_BY_SOCKET',
    UPDATE_STATUSES_BY_SOCKET = 'DEVICES.UPDATE_STATUSES_BY_SOCKET',

    CHANGE_USER_NEARBY_ALERT_SETTINGS_REQUEST = 'DEVICES.CHANGE_USER_NEARBY_ALERT_SETTINGS_REQUEST',
    CHANGE_USER_NEARBY_ALERT_SETTINGS_SUCCESS = 'DEVICES.CHANGE_USER_NEARBY_ALERT_SETTINGS_SUCCESS',
    CHANGE_USER_NEARBY_ALERT_SETTINGS_FAILURE = 'DEVICES.CHANGE_USER_NEARBY_ALERT_SETTINGS_FAILURE',

    CHANGE_USER_NEARBY_ALERT_SETTINGS_BY_SOCKET = 'DEVICES.CHANGE_USER_NEARBY_ALERT_SETTINGS_BY_SOCKET',

    CHANGE_USER_NEARBY_DEVICE_SETTINGS_BY_SOCKET = 'DEVICES.CHANGE_USER_NEARBY_DEVICE_SETTINGS_BY_SOCKET',
}

export interface IUpdateDeviceBySocket {
    type: typeof DEVICES.UPDATE_DEVICE_BY_SOCKET;
    payload: DeviceSocketUpdateDTO;
}

export interface IAddDeviceBySocket {
    type: typeof DEVICES.ADD_DEVICE_BY_SOCKET;
    payload: DeviceSocketUpdateDTO;
}

export interface IDeleteDeviceBySocket {
    type: typeof DEVICES.DELETE_DEVICE_BY_SOCKET;
    payload: DeviceResidentDTO;
}
export interface IGetDevicesRequest {
    type: typeof DEVICES.GET_DEVICES_REQUEST;
    payload: { options: devicesReqOptions; blocking: boolean };
}

export interface IGetDevicesSuccess {
    type: typeof DEVICES.GET_DEVICES_SUCCESS;
    payload: any;
}

export interface IGetDevicesFailure {
    type: typeof DEVICES.GET_DEVICES_FAILURE;
    payload: any;
}

export interface IGetUserTagDevicesRequest {
    type: typeof DEVICES.GET_USER_TAG_DEVICES_REQUEST;
    payload: { options: devicesReqOptions; blocking: boolean };
}

export interface IGetUserTagDevicesSuccess {
    type: typeof DEVICES.GET_USER_TAG_DEVICES_SUCCESS;
    payload: any;
}

export interface IGetUserTagDevicesFailure {
    type: typeof DEVICES.GET_USER_TAG_DEVICES_FAILURE;
    payload: any;
}

export interface IGetOneDeviceRequest {
    type: typeof DEVICES.GET_ONE_DEVICE_REQUEST;
    payload: { deviceId: string };
}

export interface IGetOneDevicesSuccess {
    type: typeof DEVICES.GET_ONE_DEVICE_SUCCESS;
    payload: { device: Device };
}

export interface IGetOneDevicesFailure {
    type: typeof DEVICES.GET_ONE_DEVICE_FAILURE;
    payload: any;
}

export interface IGetDeviceStatusesRequest {
    type: typeof DEVICES.GET_DEVICE_STATUSES_REQUEST;
    payload: { deviceId: string; deviceType: DeviceType };
}

export interface IGetDeviceStatusesSuccess {
    type: typeof DEVICES.GET_DEVICE_STATUSES_SUCCESS;
    payload: { statuses: DeviceStatus[]; deviceId: string };
}

export interface IGetDeviceStatusesFailure {
    type: typeof DEVICES.GET_DEVICE_STATUSES_FAILURE;
    payload: any;
}

export interface IGetAllDevicesStatusesRequest {
    type: typeof DEVICES.GET_ALL_DEVICES_STATUSES_REQUEST;
    payload: devicesReqOptions;
}

export interface IGetAllDevicesStatusesSuccess {
    type: typeof DEVICES.GET_ALL_DEVICE_STATUSES_SUCCESS;
    payload: any;
}

export interface IGetAllDevicesStatusesFailure {
    type: typeof DEVICES.GET_ALL_DEVICE_STATUSES_FAILURE;
    payload: any;
}

export interface ISetDevicesSettings {
    type: typeof DEVICES.SET_SETTINGS;
    payload: { type: DeviceType; value: DevicesSettings };
}

export interface IChangeDevicesSelected {
    type: typeof DEVICES.CHANGE_SELECTED;
    payload: { type: DeviceType; value: string };
}

export interface IChangeDeviceRequest {
    type: typeof DEVICES.CHANGE_DEVICE_REQUEST;
    payload: DeviceUpdateDTO;
}

export interface IChangeDeviceSuccess {
    type: typeof DEVICES.CHANGE_DEVICE_SUCCESS;
    payload: DeviceUpdateDTO;
}

export interface IChangeDeviceFailure {
    type: typeof DEVICES.CHANGE_DEVICE_FAILURE;
    payload: any;
}

export interface IChangeDeviceClear {
    type: typeof DEVICES.CLEAR_SUCCESS_STATE;
}

export interface IMoveManyDeviceRequest {
    type: typeof DEVICES.MOVE_MANY_DEVICE_REQUEST;
    payload: DeviceMoveDTO[];
}

export interface IMoveManyDeviceSuccess {
    type: typeof DEVICES.MOVE_MANY_DEVICE_SUCCESS;
    payload: DeviceMoveDTO[];
}

export interface IMoveManyDeviceFailure {
    type: typeof DEVICES.MOVE_MANY_DEVICE_FAILURE;
    payload: any;
}

export interface IMoveResidentWithDevicesSuccess_Devices {
    type: typeof DEVICES.MOVE_RESIDENT_WITH_DEVICES_SUCCESS;
    payload: MoveResidentWithDeviceResponceDTO[];
}

export interface IGetDeviceStatusBySoket {
    type: typeof DEVICES.GET_DEVICE_STATUS_BY_SOCKET;
    payload: { status: DeviceStatus; deviceId: string };
}

export interface IGetUserNearbyRequest {
    type: typeof DEVICES.GET_USER_NEARBY_REQUEST;
}

export interface IGetUserNearbySuccess {
    type: typeof DEVICES.GET_USER_NEARBY_SUCCESS;
    payload: any;
}

export interface IGetUserNearbyFailure {
    type: typeof DEVICES.GET_USER_NEARBY_FAILURE;
    payload: any;
}

export interface IChangeUserNearbyAlertSettingsRequest {
    type: typeof DEVICES.CHANGE_USER_NEARBY_ALERT_SETTINGS_REQUEST;
    payload: userTagSettingsDTO[];
}

export interface IChangeUserNearbyAlertSettingsSuccess {
    type: typeof DEVICES.CHANGE_USER_NEARBY_ALERT_SETTINGS_SUCCESS;
    payload: userTagSettingsDTO[];
}

export interface IChangeUserNearbyAlertSettingsFailure {
    type: typeof DEVICES.CHANGE_USER_NEARBY_ALERT_SETTINGS_FAILURE;
    payload: any;
}

export interface IChangeUserNearbyAlertSettingsBySocket {
    type: typeof DEVICES.CHANGE_USER_NEARBY_ALERT_SETTINGS_BY_SOCKET;
    payload: userTagUpdateSocketDTO;
}

export interface IGetUserNearbySettingsRequest {
    type: typeof DEVICES.GET_USER_NEARBY_SETTINGS_REQUEST;
}

export interface IGetUserNearbySettingsSuccess {
    type: typeof DEVICES.GET_USER_NEARBY_SETTINGS_SUCCESS;
    payload: any;
}

export interface IGetUserNearbySettingsFailure {
    type: typeof DEVICES.GET_USER_NEARBY_SETTINGS_FAILURE;
    payload: any;
}

export interface ISetUserNearbySettingsRequest {
    type: typeof DEVICES.SET_USER_NEARBY_SETTINGS_REQUEST;
    payload: setUserNearbyDeviceSettingsDTO;
}

export interface ISetUserNearbySettingsSuccess {
    type: typeof DEVICES.SET_USER_NEARBY_SETTINGS_SUCCESS;
    payload: any;
}

export interface ISetUserNearbySettingsFailure {
    type: typeof DEVICES.SET_USER_NEARBY_SETTINGS_FAILURE;
    payload: any;
}

export interface IChangeUserNearbyDeviceSettingsBySocket {
    type: typeof DEVICES.CHANGE_USER_NEARBY_DEVICE_SETTINGS_BY_SOCKET;
    payload: setUserNearbyDeviceSettingsDTO;
}

export interface IChangeDevicesWifiRequest {
    type: typeof DEVICES.CHANGE_DEVICES_WIFI_REQUEST;
    payload: changeDevicesWiFiDTO;
}

export interface IChangeDevicesWifiSuccess {
    type: typeof DEVICES.CHANGE_DEVICES_WIFI_SUCCESS;
    payload: any;
}

export interface IChangeDevicesWifiFailure {
    type: typeof DEVICES.CHANGE_DEVICES_WIFI_FAILURE;
    payload: any;
}
export type DeviceActionType =
    | IChangeUserNearbyDeviceSettingsBySocket
    | IGetUserNearbySettingsSuccess
    | IChangeUserNearbyAlertSettingsBySocket
    | IGetUserNearbySuccess
    | IGetUserTagDevicesFailure
    | IGetUserTagDevicesSuccess
    | IGetDevicesRequest
    | IGetOneDeviceRequest
    | IGetDevicesSuccess
    | IGetOneDevicesSuccess
    | IGetDevicesFailure
    | IGetOneDevicesFailure
    | IGetDeviceStatusesRequest
    | IGetDeviceStatusesSuccess
    | IGetDeviceStatusesFailure
    | ISetDevicesSettings
    | IChangeDeviceFailure
    | IChangeDeviceRequest
    | IChangeDeviceSuccess
    | IMoveManyDeviceRequest
    | IMoveManyDeviceFailure
    | IMoveManyDeviceSuccess
    | IGetDeviceStatusBySoket
    | IDeleteResidentBySocket
    | IDeleteDeviceFromResidentBySocket
    | IAddDeviceToResidentBySocket
    | IUpdateDeviceBySocket
    | IChangeDevicesSelected
    | IMoveResidentWithDevicesRequest
    | IMoveResidentWithDevicesSuccess_Devices
    | IMoveResidentWithDevicesFailure
    | IMoveResidentWithDevicesBySoket
    | IAddDeviceBySocket
    | IDeleteDeviceBySocket
    | IGetAllDevicesStatusesFailure
    | IGetAllDevicesStatusesRequest
    | IGetAllDevicesStatusesSuccess
    | IChangeDeviceClear;
// | IUpdateResidentStatusesBySoket;
